/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'backbone',
        'assets/js/modules/utils',
        'assets/js/modules/screen',
        'assets/js/modules/pages/start/view/pricingCalcItemView',
        'assets/js/modules/widgets/elements/switcher/switcherView',
        'assets/js/modules/widgets/elements/switcher/switcherModel',
        'assets/js/modules/widgets/elements/radio/radioModel',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel'
    ],
    function($, _, backbone, utils, screen, PricingCalcItemView, SwitcherView, SwitcherModel, RadioModel, OptionModel, OptionValueModel) {
        return PricingCalcItemView.extend({
            /**
             * @param {PricingCalcSkuModel} pricingCalcSku
             * @returns {function}
             */
            skuOptionTmpl: function(pricingCalcSku) {
                var tmpl = _.template(this.skuOptionTemplate);

                return tmpl({
                    id: pricingCalcSku.get('sku').get('id'),
                    quantity: utils.formatNumber(pricingCalcSku.get('sku').get('quantity')),
                    selected: pricingCalcSku.get('selected'),
                    enabled: pricingCalcSku.get('enabled')
                });
            },

            renderOptions: function() {
                var _this = this;
                this.clearOptionsElement();

                var selectedSides = this.model.get('sideCount');
                const isFoilActive = this.$el.find('.product-option-choices').data('feature-dvs-foil');

                this.model
                    .get('options')
                    .where({ enabled: true, visible: true })
                    .forEach(function(pricingCalcOption) {
                        const optionName = pricingCalcOption.get('option').get('name');

                        if (
                            !isFoilActive &&
                            (optionName === OptionModel.NAME_FRONT_FOIL_COLOR || optionName === OptionModel.NAME_BACK_FOIL_COLOR)
                        ) {
                            return;
                        }

                        const optionValues = pricingCalcOption.get('optionValues');

                        optionValues.forEach((pricingCalcOptionValue, index) => {
                            const optionValueName = pricingCalcOptionValue.get('optionValue').get('name');

                            if (
                                !isFoilActive &&
                                (optionValueName === OptionValueModel.NAME_FRONT_COATING_FOIL ||
                                    optionValueName === OptionValueModel.NAME_BACK_COATING_FOIL)
                            ) {
                                optionValues.remove(optionValues.at(index));
                            }
                        });

                        // do not render back coating for single-sided on mobile
                        if (
                            !screen.isXs() ||
                            selectedSides !== 1 ||
                            pricingCalcOption.get('option').get('name') !== OptionModel.NAME_BACK_COATING
                        ) {
                            _this.optionTmpl(pricingCalcOption);
                        }
                    });

                this.$options.find('select').selectBoxIt({ autoWidth: false });
            },

            /**
             * @param {PricingCalcOptionModel} pricingCalcOption
             * @returns {undefined}
             */
            optionTmpl: function(pricingCalcOption) {
                var selectedPricingCalcOptionValue = pricingCalcOption.getSelectedOptionValue();

                if (!selectedPricingCalcOptionValue.get('visible')) {
                    return;
                }

                var option = pricingCalcOption.get('option');
                var tmpl = _.template(this.optionTemplate);
                var selectedOptionValue = selectedPricingCalcOptionValue.get('optionValue');
                var image = this.getImageForOptionValue(selectedOptionValue);
                var selectClass = 'select-simple';
                var valuesHtml = this.getOptionValuesHtmlForSelect(pricingCalcOption);

                this.$options.append(
                    tmpl({
                        id: pricingCalcOption.cid,
                        name: option.get('name'),
                        title: option.get('title'),
                        description: selectedOptionValue.get('description'),
                        isAlert: selectedOptionValue.get('isAlert'),
                        image: image,
                        valuesHtml: valuesHtml,
                        selectClass: selectClass,
                        optionValuesAmount: pricingCalcOption.get('optionValues').length
                    })
                );
            },

            /**
             * @param {PricingCalcOptionModel} pricingCalcOption
             * @return {string}
             */
            getOptionValuesHtmlForSelect: function(pricingCalcOption) {
                var _this = this;

                var html = pricingCalcOption
                    .get('optionValues')
                    .where({ visible: true })
                    .reduce(function(html, pricingCalcOptionValue) {
                        return (
                            html +
                            _this.getOptionValueHtml(
                                pricingCalcOption,
                                pricingCalcOptionValue,
                                _this.getPricingCalcOptionValueIsEnabled(pricingCalcOption, pricingCalcOptionValue)
                            )
                        );
                    }, '');

                return this.getOptionHtml(pricingCalcOption.cid, html);
            },

            clearOptionsElement: function() {
                this.$options
                    .children('li')
                    .not('.product-size-list-item')
                    .remove();
            },

            renderCoating: function(sidesValue) {
                var $backCoating = this.$options.find('li[data-option-name="back_coating"]');
                if ($backCoating.length) {
                    if (sidesValue === 1) {
                        $backCoating.hide();
                    } else {
                        $backCoating.show();
                    }
                }
            },

            skuOptionTemplate: [
                '<option value="<%- id %>"<% if (selected) {%> selected<% } %><% if (!enabled) {%> disabled<% } %>',
                '><%- quantity %>',
                '</option>'
            ].join(''),

            /**
             * @returns {string}
             */
            optionTemplate: [
                '<li data-option-name="<%- name %>" data-option-values-amount="<%- optionValuesAmount %>">',
                '<div class="product-choice">',
                '<div class="product-choice-label <%= selectClass %>">',
                '<label for="<%- id %>"><%= title %></label>',
                '</div>',
                '<div class="product-choice-control <%- selectClass %>">',
                '<%= valuesHtml %>',
                '</div>',
                '</div>',
                '</li>'
            ].join('\n')
        });
    }
);
